// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

import {IProductEnvironment} from "./FacilitiesEvaluationEnvironment";
import {EProductType} from "../javascript.lib.mojo-base/model/ProductType";
import {FacilityAccessibilityProduct4} from "../product.facility/model/FacilityAccessibilityProduct4";

export const environment: IProductEnvironment = {

  name: "TFL: Facilities",
  filename: 'environment.facilities-847076.ts',

  isDevelopment: false,
  isProduction: true,
  isTest: false,

  authenticationConfig: {

    emailLink: false,
    textMessage: true,
    usernamePassword: true
  },

  firebaseConfig: {
    databaseURL: "https://facilities-847076-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "facilities-847076",
    storageBucket: "facilities-847076.appspot.com",

    apiKey: "AIzaSyAMX5MQ2Sf5THSh5XDqZLqF9wCmuq5FZIo",
    authDomain: "facilities-847076.firebaseapp.com",
    messagingSenderId: "679729686182",
    appId: "1:679729686182:web:0c8d4097d29b6eb002f667"
  },

  // curl -iLS https://us-central1-$_TARGET_ENV.cloudfunctions.net/public/functions/info
  cloudFunctionsUrl: 'https://us-central1-facilities-847076.cloudfunctions.net',


  nocoDbConfig: {
    // httpServer: 'http://localhost:8080',
    httpServer: 'https://mobilitymojo-spot.com',
    user: 'test@mobilitymojo.com',
    password: 'test@mobilitymojo.com',
    authorization: 'Basic bW9iaWxpdHk6bW9qbw==',
    projectTitle: '2024 - Grosvenor and The Crown Estate',
  },

  productConfig: {

    firebaseAnswersRoot: '/answers-x/facilities',
    // product:  ProductHelper.cloneProduct( new FacilityAccessibilityProduct(), true )
    product:  FacilityAccessibilityProduct4.INSTANCE,
    productType: EProductType.facilities,
    canCommentOnClusters: true,
    canEditClusters: false,

  },

  preview: {

    clusterSupport: true,
    fireworksEnabled: true,
    reportGeneration2: true,
  },

};
